import * as R from 'remeda';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { ExpectedQuerySchema, expectedQuerySchema } from './types';

export const parseIncomingViewQuery = (
  data: unknown,
  options?: { id: number }
): ExpectedQuerySchema | null => {
  const parsed = expectedQuerySchema.safeParse(data);

  if (!parsed.success) {
    if (options?.id)
      // oxlint-disable-next-line no-console
      console.warn(`Saved view with id ${options.id} could not be parsed`);

    return null;
  }

  return parsed.data;
};

// Only the meaningful parts of a filter item matter for staleness; ignore
// the grid-generated `id` and any extra flags (e.g. `isValid`).
// The order is irrelevant too — filters with a missing column get moved to the
// end of the current filter items, which would otherwise read as a change.
const normalizeFilterItems = (
  items: Pick<GridFilterItem, 'field' | 'operator' | 'value'>[]
) =>
  R.pipe(
    items,
    R.map(({ field, operator, value }) => ({ field, operator, value })),
    R.sortBy(
      item => item.field,
      item => item.operator,
      item => JSON.stringify(item.value) ?? ''
    )
  );

export const isSavedViewStale = (
  savedViewQuery: GridFilterItem[],
  currentFilterItems: Pick<GridFilterItem, 'field' | 'operator' | 'value'>[]
) =>
  !R.isDeepEqual(
    normalizeFilterItems(savedViewQuery),
    normalizeFilterItems(currentFilterItems)
  );

const SCHEMA_COLUMN_PREFIX = 'field';

export const retrieveColumnLabel = (value: string) =>
  value.startsWith(`${SCHEMA_COLUMN_PREFIX}.`)
    ? R.first(value.replace(`${SCHEMA_COLUMN_PREFIX}.`, '').split('.'))
    : value;
